import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import wicTeam from './pictures/friendsgiving/wicOfficerTeam.jpeg';
import attendees1 from './pictures/friendsgiving/attendees1.jpeg';
import attendees2 from './pictures/friendsgiving/attendees2.jpeg';
import attendees3 from './pictures/friendsgiving/attendees3.jpeg';
import attendees4 from './pictures/friendsgiving/attendees4.jpeg';
import attendees5 from './pictures/friendsgiving/attendees5.jpeg';
import attendees6 from './pictures/friendsgiving/attendees6.jpeg';
import attendees7 from './pictures/friendsgiving/attendees7.jpeg';
import attendees8 from './pictures/friendsgiving/attendees8.jpeg';
import food from './pictures/friendsgiving/food.jpeg';

const Friendsgiving = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Friendsgiving Annual Celebration</h2>
                    <p class="site-post-meta">November 12, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you so much for joining us yesterday for our annual Friendsgiving Annual Celebration 🍂! We had a wonderful time connecting with so many WiC members and Allen School faculty! We hope everyone enjoyed some delicious catered food and a fun time coming up with some great story plot ideas with each other 😉. 
                    <br></br>
                    <br></br>                    
                    We all had the opportunity to relax and unwind while enjoying some great company with fellow WiC members and Allen School faculty. We also got to enjoy some amazing catered dishes!
                    <br></br>
                    <br></br>
                    We hope everyone had an amazing time and were able to connect with WiC members and Allen School faculty, while taking a break!                    
                    
                    </p>
                    <img src={wicTeam} alt="WiC officer team posing for a picture after event."/>
                    <img src={attendees1} alt="Attendees at the event"/>
                    <img src={food} alt="Catered food at the event."/>
                    <img src={attendees2} alt="Attendees at the event"/>
                    <img src={attendees3} alt="Attendees at the event"/>
                    <img src={attendees4} alt="Attendees at the event"/>
                    <img src={attendees5} alt="Attendees at the event"/>
                    <img src={attendees6} alt="Attendees at the event"/>
                    <img src={attendees7} alt="Attendees at the event"/>
                    <img src={attendees8} alt="Attendees at the event"/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Friendsgiving;
